<template>
  <section class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-[#f4f4f4]">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="max-w-4xl sm:max-w-5xl lg:max-w-6xl mx-auto">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-[#0b105d] mb-12 sm:mb-16"
          data-aos="fade-up"
        >
          {{ $t('aboutUsPage.solutionFocused.title') }}
        </h2>

        <div class="space-y-4 sm:space-y-6">
          <div
            v-for="(key, index) in challengeKeys"
            :key="key"
            class="group"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
          >
            <div class="relative">
              <div
                class="absolute inset-0 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity"
              ></div>
              <div
                class="relative bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
              >
                <div class="flex items-start gap-3 sm:gap-4 md:gap-5">
                  <div class="flex-shrink-0">
                    <div
                      class="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-lg sm:rounded-xl flex items-center justify-center text-white font-bold text-base sm:text-lg shadow-lg"
                    >
                      {{ index + 1 }}
                    </div>
                  </div>
                  <div class="flex-grow min-w-0">
                    <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2">
                      {{ $t(`aboutUsPage.solutionFocused.${key}`).split(':')[0] }}
                    </h3>
                    <p class="text-gray-700 leading-relaxed text-sm sm:text-base">
                      {{
                        $t(`aboutUsPage.solutionFocused.${key}`)
                          .split(':')
                          .slice(1)
                          .join(':')
                          .trim()
                      }}
                    </p>
                  </div>
                  <CheckCircleIcon
                    class="w-5 h-5 sm:w-6 sm:h-6 text-green-500 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CheckCircleIcon } from 'lucide-vue-next'

const challengeKeys = [
  'interpretingData',
  'streamliningBusiness',
  'modelTraining',
  'dynamicAdaptation',
  'performanceManagement',
]
</script>
